export default __webpack_public_path__ + "static/media/icon-bestellung-eingang-debitor.9e29b879.svg";